<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <el-alert
          v-if="status === 422"
          title="Категория содержит статьи."
          type="error"
          effect="dark"
        >
        </el-alert>
        <el-alert
          v-if="status === 200"
          title="Категория успешно удалена."
          type="success"
          effect="dark"
        >
        </el-alert>
        <div class="row m-4">
          <div class="col-md-2">
            <h4>Категории статей</h4>
          </div>
          <div class="col-md-2">
            <el-button
              type="success"
              @click="goToPage('/article-section/create')"
              >Создать новую категорию</el-button
            >
          </div>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск">
          <el-row>
            <el-col :span="10">
              <el-form-item label="Поиск по названию">
                <el-col :span="14">
                  <el-input
                    v-model="query.q"
                    @input="searchByName"
                    @change="getSections"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Сортировка">
                <el-select
                  :value="query.sort.by + '.' + query.sort.order"
                  :width="300"
                  @change="sortCategories"
                >
                  <el-option
                    value="title.asc"
                    label="Название (А-Я)"
                  ></el-option>
                  <el-option
                    value="title.desc"
                    label="Название (Я-А)"
                  ></el-option>
                  <el-option
                    value="sort.asc"
                    label="Cортировка по возрастанию"
                  ></el-option>
                  <el-option
                    value="sort.desc"
                    label="Cортировка по убыванию"
                  ></el-option>
                  <el-option
                    value="activity.asc"
                    label="Активность по возрастанию"
                  ></el-option>
                  <el-option
                    value="activity.desc"
                    label="Активность по убыванию"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="sections" style="width: 100%">
          <el-table-column prop="id" label="Id" width="50"></el-table-column>
          <el-table-column prop="title" label="Название"></el-table-column>
          <el-table-column prop="slug" label="Slug"></el-table-column>
          <el-table-column prop="article_count" label="Количество статей"></el-table-column>
          <el-table-column prop="sort" label="Сортировка"></el-table-column>
          <el-table-column label="Активность">
            <template slot-scope="scope">
              <p v-if="!sections[scope.$index].activity">Нет</p>
              <p v-if="sections[scope.$index].activity">Да</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Действия" width="400">
            <template slot-scope="scope">
              <div class="article-sections__nav">
                <el-button
                  v-if="sections[scope.$index].activity"
                  size="mini"
                  type="primary"
                  plain
                  @click="(e) => hideRow(e, sections[scope.$index].id)"
                >
                  Скрыть
                </el-button
                >
                <el-button
                  v-if="!sections[scope.$index].activity"
                  size="mini"
                  type="primary"
                  plain
                  @click="(e) => restoreRow(e, sections[scope.$index].id)"
                >
                  Восстановить
                </el-button>
                <el-button
                  size="mini"
                  @click="(e) => updateRow(e, sections[scope.$index].id)"
                >
                  Изменить
                </el-button>
                <el-popconfirm
                  :title="'Удалить эту категорию?'"
                  :hide-icon="true"
                  class="section-remove"
                  :confirmButtonText="'Да'"
                  :cancelButtonText="'Нет'"
                  @onConfirm="(e) => deleteRow(sections[scope.$index].id, e)"
                >
                  <template #reference>
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      class="el-table__row--remove-btn"
                    >
                      Удалить
                    </el-button>
                  </template>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="paginator.total"
          :current-page.sync="current"
          @current-change="getPage(current)"
          :hide-on-single-page="true"
          :page-size="paginator.per_page"
          :page-count="paginator.last_page"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "../../store/mutation-types.js";
import qs from 'qs';

export default {
  name: "Advantages",
  data: function () {
    return {
      status: 0,
      sections: [],
      paginator: [],
      message: "",
      query: {
        q: null,
        sort: {
          by: "sort",
          order: "asc"
        },
        limit: 8,
      },
      current: null,
      searchTimeout: null,
    };
  },
  mounted() {
    this.getSections();
  },
  methods: {
    getSections: function () {
      this.$store.commit(SETPRELOADER_STATE, true);

      const queryParams = qs.stringify(this.query, {skipNulls: true});

      axios
        .get(`/blog/section?${queryParams}`)
        .then((response) => {
          this.$store.commit(SETPRELOADER_STATE, false);

          this.sections = response.data.data;
          this.paginator = response.data.meta;
          this.current = response.data.meta.current_page;
        })
        .catch((errors) => {
          this.$store.commit(SETPRELOADER_STATE, false);

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    getPage: function (page) {
      if (page !== null) {
        this.$store.commit(SETPRELOADER_STATE, true);

        const queyParams = qs.stringify(this.query, {skipNulls: true});

        axios
          .get(`/blog/section?page=${page}&${queyParams}`)
          .then((response) => {
            this.$store.commit(SETPRELOADER_STATE, false);
            this.paginator = response.data.meta;
            this.sections = response.data.data;

            this.current = response.data.meta.current_page;
          })
          .catch((errors) => {
            this.$store.commit(SETPRELOADER_STATE, false);

            if (errors.response.status === 401) {
              this.$router.push("/login");
            }
          });
      }
    },
    handleClick() {
      console.log("click");
    },
    goToPage: function (path) {
      this.$router.push(path);
    },
    deleteRow: function (id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .delete(`/blog/section/${id}`)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.status = response.status;

          this.sections = this.sections.filter((el) => el.id !== id);
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.status = errors.response.status;

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }

          if (errors.response.status === 422) {
            this.message = "Данная категория содержит статьи.";
          }
        });
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains('el-button') ? t : t.parentNode
    },
    hideRow: function (e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = this.getTarget(e)

      btn.style.pointerEvents = "none";

      axios
        .post(`/blog/section/${id}/hide`)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          btn.style.pointerEvents = "all";
          this.status = response.status;

          this.sections = [...this.sections.map((item) => {
            if (item.id === id) {
              item.activity = false
            }
        
            return item
          })];
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          btn.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    restoreRow: function (e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = this.getTarget(e)

      btn.style.pointerEvents = "none";

      axios
        .post(`/blog/section/${id}/restore`)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          btn.style.pointerEvents = "all";

          this.status = response.status;

          this.sections = [...this.sections.map((item) => {
            if (item.id === id) {
              item.activity = true;
            }

            return item
          })];
        })
        .catch((errors) => {
          btn.style.pointerEvents = "all";
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    updateRow: function (e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = e.target;
      btn.style.pointerEvents = "none";

      axios
        .get(`blog/section/${id}`)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          const category = response.data;

          this.$store.dispatch("fetchArticleCategory", category);

          this.$router.push("/article-section/" + id + "/update");
        })
        .catch(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";
        });
    },
    searchByName(value) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
          if (!value) this.query.q = null;
          this.getSections()
        }, 500);
    },
    sortCategories: function (value) {
      this.query.sort.by = value.split('.')[0]
      this.query.sort.order = value.split('.')[1]

      this.getSections()
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0;
}

.section-remove {
  margin-left: 10px;
}

.article-sections__nav {
  display: flex;
  justify-content: space-around;
  max-width: 320px;
}
</style>